import React, { useState, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import ExportExcel from '../../../container/export-excel/ExportExcel';
import LineForTrend from '../../graph/line/LineForTrend';
import ColumnForTrend from '../../graph/bar/ColumnForTrend';
import PieForTrend from '../../graph/pie/PieForTrend';
import TableForTrend from '../../table/TableForTrend';

const ResultTab = (props) => {
  switch (props.reportType) {
    case "volume": {
      return (
        <>
          <a name="line" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.lineTab}>Line</a>
          &nbsp;
          <a name="column" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.columnTab}>Column</a>
          &nbsp;
          <a name="pie" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.pieTab}>Pie</a>
          &nbsp;
          <a name="table" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    case "detail": {
      return (
        <>
          <a name="line" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.lineTab}>Line</a>
          &nbsp;
          <a name="column" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.columnTab}>Column</a>
          &nbsp;
          <a name="pie" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.pieTab}>Pie</a>
          &nbsp;
          <a name="table" reportType={props.reportType} onClick={props.handleTabClick} className={props.tabState.tableTab}>Table</a>
        </>
      )
      break;
    }
    default:
      return null;
      break;
  }

}

const TrendResult = (props) => {
  //props.resultData
  switch (props.data.reportType) {
    case "volume": {
      if (props.presentGraph.graph == 'line') {
        return (
          <ReportLine data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole}
          />
        )
      }
      else if (props.presentGraph.graph == 'column') {
        return (
          <ReportColumn data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'pie') {
        return (
          <ReportPie data={props.data} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    case "detail": {
      if (props.presentGraph.graph == 'line') {
        return (
          <ReportLine data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole}
          />
        )
      }
      else if (props.presentGraph.graph == 'column') {
        return (
          <ReportColumn data={props.data} datatype={props.datatype} timeunit={props.timeunit} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'pie') {
        return (
          <ReportPie data={props.data} excelExportFunc={props.excelExportFunc} userRole={props.userRole} />
        )
      }
      else if (props.presentGraph.graph == 'table') {
        return (
          <ReportTable data={props.data} excelExportFunc={props.excelExportFunc} />
        )
      }
      else {
        return null;
      }
      break;
    }
    default:
      return null;
      break;
  }
}

const ReportLine = (props) => {
  return (
    <Tabs style={{ margin: "10px" }}>
      <TabList style={{ display: "-webkit-box" }}>
        <Tab>{props.data.query.join(' & ')}</Tab>
      </TabList>
      <TabPanel>
        <LineForTrend data={props.data} timeunit={props.timeunit} datatype="numeric" reportType={props.data.reportType} reportName="트렌드" width="100%" height={800} excelExportFunc={props.excelExportFunc}
        />
      </TabPanel>
    </Tabs>
  )
}

const ReportColumn = (props) => {

  return (
    <Tabs style={{ margin: "10px" }}>
      <TabList style={{ display: "-webkit-box" }}>
        <Tab>{props.data.query.join(' & ')}</Tab>
      </TabList>
      <TabPanel>
        <ColumnForTrend data={props.data} timeunit={props.timeunit} datatype="numeric" reportType={props.data.reportType} reportName="트렌드" width="100%" height={800} excelExportFunc={props.excelExportFunc}
        />
      </TabPanel>
    </Tabs>
  )
}

const ReportPie = (props) => {
  return (
    <Tabs style={{ margin: "10px" }}>
      <TabList style={{ display: "-webkit-box" }}>
        <Tab>{props.data.query.join(' & ')}</Tab>
      </TabList>
      <TabPanel>
        <PieForTrend data={props.data} timeunit={props.timeunit} datatype="numeric" reportType={props.data.reportType} reportName="트렌드" width="100%" height={800} excelExportFunc={props.excelExportFunc}
        />
      </TabPanel>
    </Tabs>
  )
}

const ReportTable = (props) => {
  switch (props.data.reportType) {
    case "volume": {
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <TableForTrend reportType={props.data.reportType} data={props.data} pageSize={10} />
        </div>
      )
      break;
    }
    case "detail": {
      return (
        <div>
          <div className="excel-btn-container">
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => ExportExcel('trend-graph-custom', props.data, props.userRole)}>Custom Excel</a>
            <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
          </div>
          <TableForTrend reportType={props.data.reportType} data={props.data} pageSize={10} />
        </div>
      )
      break;
    }
    // case "trend": {
    //   return (
    //     <div>
    //       <div className="excel-btn-container">
    //         <a className="button purple_line" style={{ margin: "0px 10px 10px 0px" }} onClick={() => props.excelExportFunc()}>Excel</a>
    //       </div>
    //       <TableForTrend reportType={props.data.reportType} data={props.data} pageSize={10} />
    //     </div>
    //   )
    //   break;
    // }
    default:
      return null;
      break;
  }
}

const TrendVolumeResult = (props) => {
  const [tabState, setTabState] = useState({
    lineTab: 'button tabBlue_off',
    columnTab: 'button tabBlue_off',
    pieTab: 'button tabBlue_off',
    tableTab: 'button tabBlue_off',
    mapTab: 'button tabBlue_off'
  })
  const [presentGraph, setPresentGraph] = useState({
    reportType: "",
    graph: "",
  })

  useEffect(() => {
    if (props.data) {
      switch (props.data.reportType) {
        case "volume": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          break;
        }
        case "detail": {
          if (presentGraph.reportType == "" && presentGraph.graph == "") {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          else if (presentGraph.reportType != props.data.reportType) {
            setPresentGraph({
              reportType: props.data.reportType,
              graph: "line"
            })
          }
          break;
        }
        default:
          break;
      }
    }
  }, [props.data])

  useEffect(() => {
    switch (presentGraph.graph) {
      case "line": {
        setTabState({
          lineTab: 'button tabBlue_on',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "column": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_on',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "table": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_on',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "pie": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_on',
          mapTab: 'button tabBlue_off'
        })
        break;
      }
      case "map": {
        setTabState({
          lineTab: 'button tabBlue_off',
          columnTab: 'button tabBlue_off',
          tableTab: 'button tabBlue_off',
          pieTab: 'button tabBlue_off',
          mapTab: 'button tabBlue_on'
        })
        break;
      }
      default:
        break;
    }
  }, [presentGraph.graph])

  const handleTabClick = (e) => {
    setPresentGraph({
      ...presentGraph,
      graph: e.target.getAttribute('name')
    })
  }

  return (
    <>
      {React.useMemo(() =>
        props.data ?
          <>
            <div className="graphType">
              <ResultTab reportType={props.data.reportType} tabState={tabState} handleTabClick={handleTabClick} />
            </div>
            <div className="output">
              <TrendResult presentGraph={presentGraph}
                data={props.data} excelExportFunc={() => ExportExcel('trend-graph', props.data, props.userRole)}
                userRole={props.userRole} timeunit={props.onTimeUnitBtn}
              />
            </div>
          </>
          : <div style={{ height: "400px" }}></div>
        , [props.data, presentGraph, tabState])}

    </>
  )
}

export default TrendVolumeResult;